import { ApiClient } from '../../client';
import {
  Facility,
  CreateFacilityRequest,
  UpdateFacilityRequest,
  FacilitiesQueryParams,
  FacilityResponse,
  FacilityQueryResponse,
} from './types';
import { convertDatesToStrings } from '../../../../utils/dateConversion';

export class FacilityService {
  constructor(private api: ApiClient) {}

  async getAll(params?: FacilitiesQueryParams) {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.advancedSearch)
      queryParams.append(
        'advancedSearch',
        JSON.stringify(params.advancedSearch)
      );
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortDirection)
      queryParams.append('sortDirection', params.sortDirection);
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());

    const query = queryParams.toString();
    const url = `/facilities${query ? `?${query}` : ''}`;

    return this.api.get<FacilityQueryResponse>(url);
  }

  async getById(id: number) {
    return this.api.get<Facility>(`/facilities/${id}`);
  }

  async getByManufacturer(manufacturerId: number) {
    return this.api.get<{ facilities: Facility[] }>(
      `/facilities/manufacturer/${manufacturerId}`
    );
  }

  async create(data: CreateFacilityRequest) {
    // Convert Date objects to ISO strings before sending to API
    const payload = convertDatesToStrings(data);
    return this.api.post<FacilityResponse>('/facilities', payload);
  }

  async update(data: UpdateFacilityRequest) {
    // Convert Date objects to ISO strings before sending to API
    const payload = convertDatesToStrings(data);
    return this.api.put<FacilityResponse>(
      `/facilities/${data.facility_id}`,
      payload
    );
  }

  async delete(id: number) {
    return this.api.delete(`/facilities/${id}`);
  }
}
